import mixpanel from "mixpanel-browser";
import React, { useRef, useState } from "react";
import ReactPlayer from "react-player";
import { logContentBlockPressEvent } from "../../../utils/events";
import { useAppContext } from './../../../util'

function EmbedVideo({ video, thumbnail, color, tag, index, contentBlockId }) {
  const { userId, pageId } = useAppContext()
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [videoStarted, setVideoStarted] = useState(false);

  const youtubeLink = "https://www.youtube.com/embed/";
  const vimeoLink = "https://player.vimeo.com/video/";

  const videoRef = useRef(null);

  const handleVideoPlaying = () => {
    setIsVideoPlaying(!isVideoPlaying);
  };

  const borderRaduses =
    color?.elements?.shape === "Pill"
      ? "16px"
      : color?.elements?.shape === "Rounded"
      ? "16px"
      : "0px";

  let videoUrl = "";
  let videoIcon = "";
  let autoplayParam = "";

  // Conditionally set the video URL and icon based on the 'tag' prop
  if (tag === "YouTube") {
    videoUrl = `${youtubeLink}${getYoutubeVideoId(
      video
    )}?rel=0&modestbranding=1&autohide=1&mute=1&showinfo=0&controls=1`;
    videoIcon = "FaYoutube";
    autoplayParam = isVideoPlaying ? "&autoplay=1" : "";
  } else if (tag === "Vimeo") {
    videoUrl = `${vimeoLink}${getVideoId(video)}`;
    videoIcon = "FaVimeoSquare"; // Replace with the actual Vimeo icon component
    autoplayParam = isVideoPlaying ? "?autoplay=1" : "";
  }

  const handlePlay = () => {
    if (!videoStarted) {
      mixpanel.track("Web Video Played", {
        video_type: tag,
        distinct_id: userId,
        stack_id: pageId,
      });
      setVideoStarted(true);
    }
    logContentBlockPressEvent(contentBlockId);
  };

  const handleEnded = () => {
    setVideoStarted(false);
  };

  return (
    <div
      key={index}
      className="embedVideoContainer"
      style={{ borderRadius: borderRaduses, WebkitBorderRadius: borderRaduses }}
      onClick={handlePlay}
    >
      <ReactPlayer
        ref={videoRef}
        url={videoUrl}
        controls
        onPlay={handlePlay}
        onEnded={handleEnded}
        width="100%"
        height="100%"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          borderRadius: borderRaduses,
          WebkitBorderRadius: borderRaduses,
          overflow: "hidden",
        }}
      />
    </div>
  );
}

function getYoutubeVideoId(url) {
  url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  return url[2] !== undefined ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
}

function getVideoId(url) {
  let videoId = "";
  if (url.includes("vimeo.com")) {
    const match = url.match(/\/(\d+)$/);
    videoId = match ? match[1] : "";
  }
  return videoId;
}

export default EmbedVideo;
